module.exports = __webpack_public_path__ + "static/media/loader.23ae1468.gif";